export enum MarketingNarrativeFileFormats {
    PPTX = ".pptx",
    PDF = ".pdf",
    DOCX = ".docx",
    XLSX = ".xlsx",
    JPG = ".jpg",
    PNG = ".png",
    MP4 = ".mp4",
}
